exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4216424a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"/Users/pola/Documents/udemy/prototype_boxed_layout/src/assets/scss/variables.scss/";"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 88
// module chunks = 0